export default __webpack_public_path__ + "static/media/react.cc18e3dd.svg";